import { Container, Grid } from "@material-ui/core";
import Menu from "../../Components/Menu";
import styled from "@emotion/styled";
import S3 from "../../img/About_S3.png";

const S3_About = () => {
  const MainDiv = styled.div`
  padding: 20px 0;
  @media screen and (max-width:599px){
    padding: 0px 0;
  }
  `;
  const Span = styled.div`
    color: #ffffff;
    font-size: 44px;
    text-transform: uppercase;
    font-weight: 600;
    padding-bottom: 10px;
    @media screen and (max-width:1150px){
    font-size: 36px;
    }
    @media screen and (max-width:599px){
      font-size: 27px;
      padding: 28px 0 0px;
    }
  `;
  const P = styled.p`
    color: #ffffff;
    padding-top: 30px;
  `;
  return (
    <MainDiv id="Home">
      <Container>
        <Grid
          container
          justifyContent="center"
          alignContent="center"
          alignItems="center"
          className=""
        >
          <Grid xs={12} sm={12} md={6} className="">
            <img src={S3} className="img-fluid w-100" />
          </Grid>
          <Grid xs={12} sm={12} md={1}></Grid>
          <Grid xs={12} sm={12} md={5} className="text-left">
            <h1 className="fontweight">
              <Span>
                <Span >
                 <span style={{ borderBottom: "7px solid #B82E3C" }}>&nbsp; MISSION STA</span>TEMENT
                </Span>
              </Span>
            </h1>
            <P>
              To provide quality consulting services to our clients by providing
              competitive updated solutions fulfilling all requirements.
            </P>
          </Grid>
        </Grid>
      </Container>
    </MainDiv>
  );
};

export default S3_About;
